import BaseFormItem from "../BaseFormItem";
import entityFieldMetaStore from "data/meta/entityFieldMetaStore";
import ChoiceStore from "data/meta/ChoiceStore";
import { optionsForField } from "data/selectors/options";
import React from "react";
import Control from "lib/common/descriptorcontrols/ChoiceField/dropdown";

export class ChoiceFielddropdown extends BaseFormItem {

    constructor(props) {
        super(props);
        const { activeRecord, descriptor } = props;
        // these can't change
        this.info = entityFieldMetaStore.getInfo(
            activeRecord.entityKey,
            descriptor.key,
        );
        this.choice = ChoiceStore.getChoiceByKey(this.info.choiceKey);
        this.conditional = this.info.conditions && this.info.conditions.length > 0;
        this.__enablePureOverValueAndEnabledHandling();
    }

    shouldComponentUpdate(nextProps, nextState, nextContext) {
        if (this.conditional) return true;
        return super.shouldComponentUpdate(nextProps, nextState, nextContext);
    }

    render() {
        const { value, enabled } = this.state;
        return <Control
            {...this.getPlumbingProps()}
            valueKey="name"
            labelKey="label"
            options={optionsForField(
                this.info,
                this.conditional ? this.props.activeRecord : null,
                this.choice,
                true,
            )}
            value={value}
            enabled={enabled}
        />;
    }
}

export default ChoiceFielddropdown;



// WEBPACK FOOTER //
// ./app/lib/dataentry/lib/dataentryform/formitems/ChoiceField/dropdown.js